import React from "react";
import { FaEdit } from "react-icons/fa";
import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import ShowFor from '@Components/ShowFor';

const SegmentListRow = ({
  segment,
  isEditing,
  editingValues,
  handleCellClick,
  handleInputChange,
  handleSaveClick,
  handleCancelClick,
  handleEditClick,
  isSelected,
  handleCheckboxChange,
}) => {
  return (
    <tr key={segment.id} className="hover:bg-gray-100">
      <td className="px-4 py-2 border-b text-sm text-gray-800">
        <input
          type="checkbox"
          onChange={() => handleCheckboxChange(segment.id)}
          checked={isSelected(segment.id)}
        />
      </td>

      <td
        className="px-4 py-2 border-b text-sm text-gray-800 cursor-pointer"
        onClick={() => handleCellClick(segment.id)}
      >
        {isEditing ? (
          <input
            type="text"
            className="border border-gray-300 rounded px-2 py-1"
            value={editingValues.name}
            onChange={(e) => handleInputChange(e, "name")}
            onClick={(e) => e.stopPropagation()}
          />
        ) : (
          segment.name
        )}
      </td>

      <td
        onClick={() => handleCellClick(segment.id)}
        className="px-4 py-2 border-b text-sm text-gray-800 cursor-pointer"
      >
        {segment.createdByUser?.email || "N/A"}
      </td>

      <td
        onClick={() => handleCellClick(segment.id)}
        className="px-4 py-2 border-b text-sm text-gray-800 cursor-pointer"
      >
        {new Date(segment.createdAt).toLocaleDateString()}
      </td>

      <td
        onClick={() => handleCellClick(segment.id)}
        className="px-4 py-2 border-b text-sm text-gray-800 cursor-pointer"
      >
        {segment.count || 0}
      </td>

      <td className="px-4 py-2 border-b text-sm text-gray-800">
        {isEditing ? (
          <div className="flex space-x-2">
            <Button
              className="hover:underline"
              onClick={(e) => {
                e.stopPropagation();
                handleSaveClick();
              }}
            >
              Save
            </Button>
            <Button
              className="hover:underline"
              onClick={(e) => {
                e.stopPropagation();
                handleCancelClick();
              }}
            >
              Cancel
            </Button>
          </div>
        ) : (
          <ShowFor permissions={['SEGMENTS_WRITE']}>
            <Button
              className="bg-gray-200"
              onClick={(e) => {
                e.stopPropagation();
                handleEditClick(segment);
              }}
            >
              <FaEdit size={16} />
            </Button>
          </ShowFor>
        )}
      </td>
    </tr>
  );
};

export default SegmentListRow;
